export default {
  clean: () => import("/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/layouts/clean.vue"),
  default: () => import("/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/layouts/default.vue"),
  site: () => import("/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/layouts/site.vue")
}